import { useAudienceBuilderStore } from "@/stores/AudienceBuilderStore";

export type Demographics = {
  all_adults: boolean;
  age_range: string[];
  custom_age_range: string[];
  children_in_household: string[];
  education_level: string[];
  ethnicity: string[];
  income_level: string[];
  marital_status: string[];
  party: string[];
  sex: string[];
  geography_classification: string[];
};

export const defaultDemographics: Demographics = {
  all_adults: true,
  age_range: [],
  custom_age_range: [],
  children_in_household: [],
  education_level: [],
  ethnicity: [],
  income_level: [],
  marital_status: [],
  party: [],
  sex: [],
  geography_classification: [],
};

export function demographicsPayload(
  demos: Demographics,
  audienceBuilderStore: ReturnType<typeof useAudienceBuilderStore>,
) {
  const keyMap = {
    children_in_household: "familieswithchildren",
    race: "ethnicity",
    marital_status: "maritalstatus",
    party: "party_label",
  };

  const payload = Object.keys(demos).reduce(
    (acc, curr) => {
      const key = keyMap[curr as keyof typeof keyMap] || curr;
      if (key === "party_label") {
        const parties = demos[curr as keyof Demographics] as string[];

        acc[key] = parties.map((s: any) => {
          return (
            audienceBuilderStore.demographicTypes
              .find((d: any) => d.name === "party")
              ?.options?.find((o: any) => Number(o.value) === s)?.name ||
            "Unknown"
          );
        });
      } else {
        acc[key] = demos[curr as keyof Demographics];
      }
      return acc;
    },
    {} as Record<string, any>,
  );

  if (payload.age_range?.includes("custom-age-range")) {
    payload.age = payload.custom_age_range
      .map((age: any, idx: number) => {
        if (idx === 0 && age === "") {
          return 18;
        }
        return age;
      })
      .filter((v: any) => v !== "");
    payload.age_range = payload.age_range.filter(
      (v: any) => v !== "custom-age-range",
    );
  }
  delete payload.custom_age_range;

  Object.keys(payload).forEach((key) => {
    if (payload[key].length === 0 || key === "all_adults") {
      delete payload[key];
    }
  });

  return payload;
}
